import React from 'react';
import { graphql } from 'gatsby';
import pickBy from 'lodash/pickBy';

import GlobalLayout from '../components/common/Layout';

import { HTMLContent } from '../components/Content';
import SeoHelmet from '../components/common/SeoHelmet';

import Post from '../components/blog/post';
import { getFirstImage } from '../utils/ast-parser';
import { generateBlogSchema } from '../utils/schema-markup';
import imageDimensionsHelper from '../utils/populate-image-dimensions';

const BlogPostTemplate = ({ data, pageContext: { recentBlogPosts, relatedArticles, imageDimensions } }) => {
  const { markdownRemark: post, allMarkdownRemark } = data;
  const [result] = allMarkdownRemark.edges;
  const {
    node: {
      frontmatter: { legal }
    }
  } = result;
  const {
    frontmatter: { date, title, description, slug: modifiedSlug, seo },
    fields: { slug: defaultSlug, gitAuthorTime },
    htmlAst
  } = post;

  const processedHtmlAst = imageDimensionsHelper(htmlAst, imageDimensions);

  const customSeo = {
    title,
    image: (getFirstImage(processedHtmlAst) || {}).src,
    type: 'article',
    description,
    url: modifiedSlug || defaultSlug,
    ...pickBy(seo)
  };

  const blogSchema = generateBlogSchema({
    title,
    image: customSeo.image,
    itemList: seo.itemList,
    datePublished: date,
    dateModified: gitAuthorTime,
    url: customSeo.url
  });

  const richResultsSnippet = <script type="application/ld+json">{JSON.stringify(blogSchema)}</script>;

  return (
    <GlobalLayout {...{ legal }}>
      <Post
        content={processedHtmlAst}
        contentComponent={HTMLContent}
        helmet={<SeoHelmet {...customSeo}>{richResultsSnippet}</SeoHelmet>}
        lastModified={gitAuthorTime}
        {...{ title, description, recentBlogPosts, relatedArticles }}
      />
    </GlobalLayout>
  );
};

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      htmlAst
      fields {
        slug
        gitAuthorTime
      }
      frontmatter {
        date
        title
        slug
        description
        seo {
          title
          description
          image
          itemList {
            name
          }
        }
      }
    }
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/credit-health/insights/index.md/" } }) {
      edges {
        node {
          frontmatter {
            legal
          }
        }
      }
    }
  }
`;

export default BlogPostTemplate;
